import { createContext, useContext, useEffect, useReducer } from "react";

export const SelectEarthquakeContext = createContext({});

export const useSelectEarthquakeContext = () => {
  return useContext(SelectEarthquakeContext);
};

const reducer = (state, action) => {
  switch (action.type) {
    case "getRecentEarthquake":
      if (action.payload) {
        return { ...state, recentEarthquake: action.payload, isLoading: false };
      } else return { ...state, isLoading: true };
    case "selected":
      return {
        ...state,
        selectedEarthquake: {
          ...action.payload,
          Position: action.payload.Coordinates.split(",").map((item) =>
            parseFloat(item)
          ),
        },
      };
    case "isLoading":
      return { ...state, isLoading: false };
    default:
      throw Error(`Unhandled action type: ${action.type}`);
  }
};

const initialState = {
  selectedEarthquake: {},
  recentEarthquake: {},
  isLoading: true,
};

export const SelectEarthquakeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const getRecentEarthquake = async () => {
        const req = await fetch(
          "https://zen-dom.up.railway.app/autogempa",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const res = await req.json();
        const result = {
          ...res.Infogempa.gempa,
          Jam: res.Infogempa.gempa.Jam.substr(0, 5),
          Position: res.Infogempa.gempa.Coordinates.split(",").map((item) =>
            parseFloat(item)
          ),
        };
        dispatch({ type: "getRecentEarthquake", payload: result });
      };
      getRecentEarthquake();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const SelectEarthquakeContextValue = [state, dispatch];
  return (
    <SelectEarthquakeContext.Provider value={SelectEarthquakeContextValue}>
      {children}
    </SelectEarthquakeContext.Provider>
  );
};
